import React, { useState } from 'react';
import { View } from 'react-native-web';
import { useForm } from 'react-hook-form';

import config from 'app/src/config';
import { Button } from 'app/src/elements/buttons';
import ExternalLink from 'app/src/elements/ExternalLink';
import { Fields, defaultValues, EMAIL_PATTERN } from 'app/src/elements/forms';
import { Text, Title, Warning, WarningText } from 'app/src/styles';

export const FIELDS = {
  email: {
    label: 'Email',
    hint: 'Your email address',
    rules: {
      required: true,
      pattern: { value: EMAIL_PATTERN, message: 'Enter a valid email' },
    },
  },
  currentPassword: {
    label: 'Current password',
    rules: { required: true },
    inputProps: { secureTextEntry: true },
  },
  newPassword: {
    label: 'New password',
    rules: { required: true },
    inputProps: { secureTextEntry: true },
  },
  confirmPassword: {
    label: 'Confirm new password',
    rules: { required: true },
    inputProps: { secureTextEntry: true },
  },
};

const ChangePassword = () => {
  const [formStatus, setFormStatus] = useState();

  const {
    control, handleSubmit, reset, watch, formState: { errors }
  } = useForm({
    defaultValues: defaultValues({ fields: FIELDS })
  });

  const watchPassword = watch('newPassword');
  const watchConfirmation = watch('confirmPassword');

  const onSubmit = input => {
    setFormStatus('submitting');

    fetch(`${config.pti.baseUri}/mcadmin/change-password`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        Authorization: config.pti.token,
      },
      body: JSON.stringify(input)
    })
    .then(response => setFormStatus(response.ok ? 'success' : 'failure'))
    .catch(() => setFormStatus('failure'));
  };

  const fields = { ...FIELDS };

  fields.confirmPassword.rules = {
    required: true,
    validate: value => {
      if (watchPassword !== value) {
        return 'Password does not match confirmation';
      }
    }
  };

  return (
    <View style={{ width: 400, alignSelf: 'center', marginTop: 20 }}>
      <Title>Change Email Password</Title>

      {'failure' === formStatus && (
        <Warning>
          <WarningText>
            Unable to find your account. Check your email and password.
          </WarningText>
        </Warning>
      )}


      {'success' === formStatus ? (
        <Text style={{ fontWeight: 600 }}>Password changed!</Text>
      ) : (
        <>
          <Fields fields={fields} control={control} errors={errors} />

          <Button
            label="Update Password"
            onPress={handleSubmit(onSubmit)}
            wide
            disabled={'submitting' === formStatus}
          />
        </>
      )}

      <View style={{ marginTop: 20, alignSelf: 'flex-end' }}>
        <ExternalLink url="https://mail.mchost.net">
          <Text>Go to Webmail</Text>
        </ExternalLink>
      </View>
    </View>
  );
};

export default ChangePassword;
